import optimizely from 'modules/optimizely';

const bucketVisitor = (experimentId, variationId) => {
  optimizely.bucketVisitor(experimentId, variationId);
  optimizely.activate(experimentId);
};

const onDomReady = () => {
  const experiment = window.Raise.data.optimizely;
  if (experiment && experiment.bucketVisitor) {
    const { experimentId, variationId } = experiment.bucketVisitor;
    bucketVisitor(experimentId, variationId);
  }
};

export default {
  init: onDomReady,
};
